module.exports = __webpack_public_path__ + "img/outreach_boost.4fb86a4.svg";